import axios from 'axios';
import { API_BASE_URL, endpoints } from './config';

const apiClient = axios.create({
    baseURL: `${API_BASE_URL}/api`,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const submitContactForm = async (formData) => {
    try {
        const response = await apiClient.post(endpoints.contact.submit, formData);
        return response.data;
    } catch (error) {
        console.error('Error submitting contact form:', error);
        const status = error.response?.status;
        if (status === 429) {
            throw new Error('Rate limit exceeded. Please try again later.');
        } else if (status === 400) {
            throw new Error('Invalid form data. Please check your inputs.');
        } else {
            throw new Error(error.response?.data?.detail || 'Failed to submit contact form');
        }
    }
};